import { LOCALE } from '../../../../constants/activity-constants'
import React from 'react'

export function text1() {
  if (['es-AR','es-PY'].includes(LOCALE)) {
    return <>Para poder jugar debés</>
  }
  return <>Para poder jugar debes</>
}
export function text2(isMobile) {
  if (['es-AR','es-PY'].includes(LOCALE)) {
    return (
      <>
        <span>Si aún no tenés</span> ¡podés estar tranquila!
        <br /> Inscribí las claves de tus productos {isMobile && <br />}
        Nosotras.
      </>
    )
  }
  return (
    <>
      <span> Si aún no tienes</span> ¡puedes estar tranquila! <br />
      Inscribe las claves de tus productos {isMobile && <br />} Nosotras.
    </>
  )
}
export function getParagraph3() {
  if (['es-AR','es-PY', 'es-PE','es-DO','es-PR'].includes(LOCALE)) {
    return null
  }
  return (
    <p>
      <span>¡Recuerda! Debes guardar los empaques</span> de
      <br />
      las claves con los que vas a participar, para
      <br />
      reclamar tu premio.
    </p>
  )
}
